import React, { useEffect } from 'react';

const EnchargeForm = () => {
  useEffect(() => {
    // Reinitialize Encharge form when component mounts
    if (window.Encharge) {
      window.Encharge.init();
    }
  }, []);

  return (
    <div 
      className="encharge-form-embed" 
      data-encharge-form-id="dcd25141-d30d-4146-a1f8-a4868d3d88fb"
    ></div>
  );
};

export default EnchargeForm;